{
  "portalHost": "portal.swaggerhub.com",
  "createPortal": {
    "iterationLimit": 10
  },
  "portalSettings": {
    "portalNameMinLength": 3,
    "portalNameMaxLength": 40,
    "portalSubdomainMinLength": 3,
    "portalSubdomainMaxLength": 20,
    "footerContentMaxLength": 10000,
    "maxUploadSize": 5000000,
    "acceptedImageFileTypes": "image/jpeg,image/jpg,image/png,image/webp",
    "acceptedIconFileTypes": "image/gif,image/png,image/webp",
    "acceptedLogoFileTypes": "image/gif,image/png,image/jpeg,image/jpg,image/webp",
    "logoDimensions": {
      "minWidth": 64,
      "minHeight": 64
    },
    "faviconDimensions": {
      "exactWidth": 32,
      "exactHeight": 32
    },
    "primaryDimensions": {
      "maxWidth": 566,
      "maxHeight": 80
    },
    "secondaryDimensions": {
      "minWidth": 566,
      "minHeight": 320
    },
    "fontList": [
      "Inter",
      "Open Sans",
      "Montserrat",
      "Roboto",
      "Playfair Display",
      "Lato",
      "Merriweather"
    ],
    "landingPageDescriptionMaxLength": 500,
    "landingPageContentMaxLength": 10000,
    "reservedSubdomains": ["app", "api", "assets", "tools", "api-internal"]
  },
  "search": {
    "minQueryLength": 3,
    "maxQueryLength": 255,
    "infiniteScrollSize": 50
  },
  "templateSearch": {
    "size": 200
  },
  "productsSettings": {
    "maxUploadSize": 5000000,
    "acceptedLogoFileTypes": "image/gif,image/png,image/jpeg,image/jpg,image/webp",
    "logoDimensions": {
      "minWidth": 64,
      "minHeight": 64
    },
    "productNameMinLength": 3,
    "productNameMaxLength": 40,
    "productSlugMinLength": 3,
    "productSlugMaxLength": 22,
    "productDescriptionMaxLength": 110,
    "reservedSlugs": ["services", "sp-admin", "sp-portal", "redirect", "assets"]
  },
  "tableOfContents": {
    "pageSlugMinLength": 3,
    "pageSlugMaxLength": 255
  },
  "contactUrl": "https://swagger.io/tools/swaggerhub/contact-us/",
  "registryUrlSuffixes": ["swagger.json", "json", "swagger.yaml", "yaml"],
  "support": {
    "documentation": "https://support.smartbear.com/swagger/portal/docs/en/get-started.html",
    "userManagement": "https://support.smartbear.com/swagger/portal/docs/en/role-management.html",
    "openapiRenderer": "https://support.smartbear.com/swagger/portal/docs/en/integrations.html",
    "supportCname": "https://support.smartbear.com/swagger/portal/docs/en/provider-view/portal-configuration-page/custom-domain.html#custom-domain-tab",
    "supportGTM": "https://support.smartbear.com/swagger/portal/docs/en/provider-view/portal-configuration-page/custom-domain.html#google-tag-manager",
    "supportProductContent": "https://support.smartbear.com/api-hub/portal/docs/en/provider-view/product-content-page/main-screen---product-content.html",
    "customCss": "https://support.smartbear.com/swagger/portal/docs/en/provider-view/portal-configuration-page/appearance-tab/custom-css.html",
    "landingPageVisibility": "https://support.smartbear.com/swagger/portal/docs/en/provider-view/products-settings-page/general-tab---products-settings.html"
  },
  "requestAccessModal": {
    "notes": {
      "maxLength": 250
    }
  },
  "landingPage": {
    "productsInfiniteScrollSize": 30
  },
  "providerAPItable": {
    "apisInfiniteScrollSize": "20"
  },
  "media": {
    "mobile": "(max-width: 1279px)",
    "desktop": "(min-width: 1280px)",
    "tabletAndDesktop": "(min-width: 768px)"
  },
  "document": {
    "autosaveWaitingTime": 250
  },
  "templateNotesMaxLength": 255,
  "haloAiSettings": {
    "oasLinesLimit": 10000
  }
}
